// Create in Sketch

export default function SquareShapeIcon ({filled}) {

  return <>
    <svg width="24px" height="24px" viewBox="0 0 24 24">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity={filled ? 0.2 : 0}>
            <rect fill="#000000" stroke="#000000" strokeWidth="1.5" x="3.75" y="3.75" width="16.5" height="16.5" rx="2"></rect>
        </g>
    </svg>
  </>
}
